import { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import socket from "src/socket";
import { FaComments, FaTimes, FaUserCircle } from "react-icons/fa";
import messageApi from "src/api/message";

const ChatWidget = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      setCurrentUser({ uid: userId });
      socket.emit("join", userId);
    }
  }, []);

  const fetchWidgetData = useCallback(async () => {
    if (!currentUser?.uid) return;
    try {
      const res = await messageApi.getConversations(currentUser.uid);
      if (Array.isArray(res.data)) {
        setConversations(res.data);
        const total = res.data.reduce((sum, c) => sum + (c.unread || 0), 0);
        setUnreadCount(total);
      }
    } catch (err) {
      console.error("Widget Fetch Error:", err);
    }
  }, [currentUser]);

  useEffect(() => {
    fetchWidgetData();
    socket.on("receiveMessage", (msg) => {
      // Agar user pehle se chat page par nahi hai tabhi count badhao
      if (!location.pathname.includes("/chat/")) {
        fetchWidgetData();
        // Option: Play notification sound here
      }
    });
    return () => socket.off("receiveMessage");
  }, [currentUser, location.pathname, fetchWidgetData]);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Floating Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="bg-orange-500 text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform relative"
      >
        {isExpanded ? <FaTimes size={24} /> : <FaComments size={24} />}
        {unreadCount > 0 && !isExpanded && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center border-2 border-white font-bold">
            {unreadCount}
          </span>
        )}
      </button>

      {/* Expanded List */}
      {isExpanded && (
        <div className="absolute bottom-16 right-0 w-80 bg-white shadow-2xl rounded-2xl border border-gray-100 overflow-hidden flex flex-col max-h-[400px]">
          <div className="p-4 bg-orange-500 text-white font-bold flex justify-between">
            <span>Recent Chats</span>
            {unreadCount > 0 && (
              <span className="text-xs bg-white text-orange-500 px-2 rounded-full">
                {unreadCount} New
              </span>
            )}
          </div>
          <div className="flex-1 overflow-y-auto">
            {conversations.length === 0 ? (
              <p className="p-10 text-center text-gray-400 text-sm">
                No recent messages
              </p>
            ) : (
              conversations.map((c) => (
                <div
                  key={c.userId}
                  onClick={() => {
                    navigate(`/chat/${c.userId}`);
                    setIsExpanded(false);
                  }}
                  className="p-3 border-b hover:bg-gray-50 cursor-pointer flex items-center gap-3"
                >
                  <FaUserCircle className="text-3xl text-gray-300" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-800 truncate">
                      User {c.userId.slice(-6)}
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                      {c.lastMessage}
                    </p>
                  </div>
                  {c.unread > 0 && (
                    <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                  )}
                </div>
              ))
            )}
          </div>
          <button
            onClick={() => {
              navigate("/conversations");
              setIsExpanded(false);
            }}
            className="p-3 text-center text-sm text-orange-500 font-bold border-t hover:bg-gray-50"
          >
            View All Messages
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
